export default {
  get subDomain() {
    const subDomainUrl = window.location.hostname.split('.')[0];
    const domainUrl = window.location.hostname.split('.')[1];
    return `${subDomainUrl}${domainUrl}`;
  },
};
